var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class RedirectToPatientPortalEmbedViewModel {
    constructor(container) {
        this.redirectToPatientPortalEmbedUIManager = container.redirectToPatientPortalEmbedUIManager;
    }
    get healthcareOrganization() {
        if (this.redirectToPatientPortalEmbedUIManager.healthcareOrganization === NOT_LOADED)
            return NOT_LOADED;
        return this.redirectToPatientPortalEmbedUIManager.healthcareOrganization;
    }
    get patientPortalName() {
        var _a, _b;
        if (this.healthcareOrganization === NOT_LOADED)
            return NOT_LOADED;
        return (_b = (_a = this.healthcareOrganization) === null || _a === void 0 ? void 0 : _a.patientPortalName) !== null && _b !== void 0 ? _b : t("your patient portal");
    }
    get patientPortalAppName() {
        var _a;
        if (this.healthcareOrganization === NOT_LOADED)
            return NOT_LOADED;
        return ((_a = this.healthcareOrganization) === null || _a === void 0 ? void 0 : _a.patientPortalName)
            ? t("the {{ patientPortalName }} app", { patientPortalName: this.healthcareOrganization.patientPortalName })
            : t("your patient portal app");
    }
    get mobileAppShouldHaveLaunched() {
        return this.redirectToPatientPortalEmbedUIManager.mobileAppShouldHaveLaunched;
    }
    get appInstallButtonVisible() {
        if (this.redirectToPatientPortalEmbedUIManager.appInstallURL === NOT_LOADED)
            return NOT_LOADED;
        return !!this.redirectToPatientPortalEmbedUIManager.appInstallURL;
    }
    installApp() {
        if (this.redirectToPatientPortalEmbedUIManager.appInstallURL === NOT_LOADED ||
            this.redirectToPatientPortalEmbedUIManager.appInstallURL === null)
            return;
        window.open(this.redirectToPatientPortalEmbedUIManager.appInstallURL);
    }
    async launchOnWeb() {
        await this.redirectToPatientPortalEmbedUIManager.launchEmbed(true);
    }
}
__decorate([
    computed
], RedirectToPatientPortalEmbedViewModel.prototype, "healthcareOrganization", null);
__decorate([
    computed
], RedirectToPatientPortalEmbedViewModel.prototype, "patientPortalName", null);
__decorate([
    computed
], RedirectToPatientPortalEmbedViewModel.prototype, "patientPortalAppName", null);
__decorate([
    computed
], RedirectToPatientPortalEmbedViewModel.prototype, "mobileAppShouldHaveLaunched", null);
__decorate([
    computed
], RedirectToPatientPortalEmbedViewModel.prototype, "appInstallButtonVisible", null);
